import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { EditIncomeDrawdownStatic } from "./EditIncomeDrawdownStatic";
import { ExistingContributionStatic } from "./ExistingContributionStatic";
import { ExistingRegularCryStatic } from "./ExistingRegularCryStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
}

export const EditIncomeDrawdownInstructionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const EditIncomeDrawdownInstructionStore: EditIncomeDrawdownStatic = new EditIncomeDrawdownStatic();
export const ExistingContributionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ExistingContributionStore: ExistingContributionStatic = new ExistingContributionStatic();
export const ExistingRegularCryDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ExistingRegularCryStore: ExistingRegularCryStatic = new ExistingRegularCryStatic();

